export const httpToHttps = (url) => {
    if (url.indexOf("http://") === 0) {
        return url.replace("http://", "https://");
    }
    return url;
}